import ReactDOM from 'react-dom/client';
import './index.css';
import './polyfills';
import App from './App/App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);
